import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  border-bottom: ", " solid\n    ", ";\n\n  &:hover {\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &:visited {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLink = styled(Text.withComponent('a'))(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.link.colors.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.link.borders.width;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.link.colors.border;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.link.colors.textHover;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.link.colors.borderHover;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.link.colors.textVisited;
});
StyledLink.propTypes = {
  /**
   * Text of the link.
   */
  children: PropTypes.string.isRequired
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A link to an action or another resource.
 */

var Link = function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      target = _ref.target,
      rest = _objectWithoutProperties(_ref, ["children", "href", "onClick", "target"]);

  return React.createElement(StyledLink, _extends({
    href: href,
    onClick: onClick,
    target: target,
    rel: target === '_blank' ? 'noreferrer noopener' : ''
  }, rest), children);
};

Link.defaultProps = {
  onClick: null,
  target: null
};
Link.propTypes = {
  /**
   * Text of the link.
   */
  children: PropTypes.string.isRequired,

  /**
   * The location of the external resource.
   */
  href: PropTypes.string.isRequired,

  /**
   * Where to open the link.
   */
  target: PropTypes.string,

  /**
   * Gets called when the user clicks on the link.
   *
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onClick: PropTypes.func
};
/** @component */

var Link$1 = styled(Link)(_templateObject$1());

export default Link$1;
